import {
    queryDictAll,
    queryDictList,
    queryAreaTree,
    queryRegionList,
    addRegionArea,
    saveArea,
    deleteArea,
    addDict,
    updateDict,
    updateDictSort,
    queryQuotaList,
    addQuota,
    queryQuotaByUserId,
    saveRegionControl,
    saveAreaControl,
    queryClause,
    addClause,
    querySupplyCustomer,
    updateSupplyCustomer,
    deleteSupplyCustomer,
    addSupplyCustomer,
    QueryRoomList,
    SaveRoom,
    DeleteRoom,
    UpdateRoom,
    addCustomerDepartmentRelBack,
    QueryConfigPage,
    UpdateConfig,
    QueryBaseCustomer,
    QueryBaseLeftCustomer,
    UpdateMedicalItem,
    QueryDictListByClassify,
    QueryDictClassify,
    QueryDictType,
    SaveDictClassify,
    UpdateDictClassify,
    SortDictClassify,
    SaveDictType,
    UpdateDictType,
    SortDictType,
    QueryRoomTree,
    UpdateSortRoom,
    QueryDoctorList,
    deleteDict,
    QueryAgentList,
    QueryKeypointTemplate
} from '@/request/base';
import { flateTree, renderChildren } from '@/utils/common';
import { getCookies, setCookies } from '@/utils/token';
import {
    DeleteKeypointTemplate,
    DeleteTemplateAction,
    GetKeypointTemplateInfo,
    QueryTemplateAction,
    SaveKeypointTemplate,
    SaveTemplateAction,
    UpdateKeypointTemplate,
    UpdateTemplateAction
} from '../../request/base';
export default {
    namesapce: true,

    state: {
        dictType: [],
        dictInfo: {},
        areaTree: [],
        regionList: [],
        areaAll: [],
        dictList: [],
        quotaList: {},
        quotaBaseList: {},
        // commonInfo: {
        //     type: [
        //         {
        //             dictName: '客户',

        //             dictCode: '1'
        //         },
        //         {
        //             dictName: '机构',
        //             dictCode: '2'
        //         },
        //         {
        //             dictName: '个人',
        //             dictCode: '3'
        //         }
        //     ]
        // },
        clauseList: {},
        supplyList: {},
        roomList: [],
        configList: {},
        roomTree: [],
        roomSelf: [],
        rooms: [],
        agentList: {},
        isCollapse: getCookies('collapse') == '2' ? false : true
    },

    mutations: {
        SET_DICT_TYPE(state, dictType) {
            state.dictType = dictType;
        },

        SET_DICT_LIST(state, dictInfo) {
            state.dictInfo = dictInfo;
        },

        SET_AREA_TREE(state, areaTree) {
            state.areaTree = areaTree;
        },

        SET_AREA_ALL(state, areaAll) {
            let all = [{ areaName: '根目录', areaId: -1 }, ...areaAll];
            state.areaAll = all;
        },

        SET_REGION_LIST(state, regionList) {
            state.regionList = regionList;
        },

        SET_DICT_LIST_ALL(state, dictList) {
            state.dictList = dictList;
        },

        SET_QUOTA_LIST(state, quotaList) {
            state.quotaList = quotaList;
        },

        SET_QUOTA_BASE_LIST(state, quotaBaseList) {
            state.quotaBaseList = quotaBaseList;
        },

        SET_CLAUSE_LIST(state, clauseList) {
            state.clauseList = clauseList;
        },

        SET_SUPPLY_LIST(state, supplyList) {
            state.supplyList = supplyList;
        },

        SET_ROOM_LIST(state, roomList) {
            state.roomList = roomList;
        },
        SET_ROOM_TREE(state, roomTree) {
            state.roomTree = roomTree;
        },
        SET_ROOM_TREE_SELF(state, roomSelf) {
            state.roomSelf = roomSelf;
        },
        SET_CONFIG_LIST(state, configList) {
            state.configList = configList;
        },
        SET_ROOMS(state, rooms) {
            state.rooms = rooms;
        },
        SET_COLLAPSE(state, isCollapse) {
            state.isCollapse = isCollapse;
        },
        SET_AGENT_LIST(state, agentList) {
            state.agentList = agentList;
        }
    },

    actions: {
        UPDATE_QUOTA_LIST: async ({ commit }, payload) => {
            commit('SET_QUOTA_LIST', payload);
        },
        UPDATE_ROOM_LIST: async ({ commit }, payload) => {
            commit('SET_ROOMS', payload.rooms);
        },
        UPDATE_COLLAPSE: async ({ commit }, payload) => {
            setCookies('collapse', payload.status ? '1' : '2');
            commit('SET_COLLAPSE', payload.status);
        },
        DictAll: async ({ commit }, payload) => {
            let res = await queryDictAll(payload);
            if (res?.code == 200) {
                let ls = res.data?.sort((a, b) => a.sort - b.sort);
                commit('SET_DICT_LIST_ALL', ls);
            }
            return res;
        },

        DictList: async ({ commit }, payload) => {
            let res = await queryDictList(payload);
            if (res?.code == 200) {
                commit('SET_DICT_LIST', res.data);
            }
            return res;
        },

        UPDATE_DICT_LIST: async ({ commit }, list) => {
            commit('SET_DICT_LIST_ALL', list);
        },

        AddDict: async ({}, payload) => {
            let res = await addDict(payload);
            return res;
        },

        UpdateDict: async ({}, payload) => {
            let res = await updateDict(payload);
            return res;
        },

        DELETE_DICT: async ({}, payload) => {
            let res = await deleteDict(payload);
            return res;
        },

        QUERY_DICT_LIST_BY_CLASSIFY: async ({ commit }, payload) => {
            let res = await QueryDictListByClassify(payload);
            return res;
        },

        QUERY_DICT_CLASSIFY: async ({ commit }, payload) => {
            let res = await QueryDictClassify(payload);
            return res;
        },

        SAVE_DICT_CLASSIFY: async ({ commit }, payload) => {
            let res = await SaveDictClassify(payload);
            return res;
        },

        UPDATE_DICT_CLASSIFY: async ({ commit }, payload) => {
            let res = await UpdateDictClassify(payload);
            return res;
        },

        SORT_DICT_CLASSIFY: async ({ commit }, payload) => {
            let res = await SortDictClassify(payload);
            return res;
        },

        QUERY_DICT_TYPE: async ({ commit }, payload) => {
            let res = await QueryDictType(payload);
            return res;
        },

        SAVE_DICT_TYPE: async ({ commit }, payload) => {
            let res = await SaveDictType(payload);
            return res;
        },

        UPDATE_DICT_TYPE: async ({ commit }, payload) => {
            let res = await UpdateDictType(payload);
            return res;
        },

        SORT_DICT_TYPE: async ({ commit }, payload) => {
            let res = await SortDictType(payload);
            return res;
        },

        UPDATE_DICT_SORT: async ({ commit }, payload) => {
            let res = await updateDictSort(payload);
            return res;
        },

        AreaTree: async ({ commit }) => {
            let res = await queryAreaTree();
            if (res?.code == 200) {
                let list = renderChildren(res.data);
                commit('SET_AREA_TREE', list);
                commit('SET_AREA_ALL', res.data);
            }
        },

        RegionList: async ({ commit }, payload) => {
            let res = await queryRegionList(payload);
            if (res?.code == 200) {
                commit('SET_REGION_LIST', res.data);
            }
            return res;
        },

        AddRegionArea: async ({ dispatch }, payload) => {
            let res = await addRegionArea(payload);
            if (res?.code == 200) {
                dispatch('AreaTree');
            }
            return res;
        },

        SaveArea: async ({}, payload) => {
            let res = await saveArea(payload);
            return res;
        },

        DeleteArea: async ({}, payload) => {
            let res = await deleteArea(payload);
            return res;
        },

        SaveRegion: async ({}, payload) => {
            let res = await saveRegionControl(payload);
            return res;
        },

        SaveAreaControl: async ({}, payload) => {
            let res = await saveAreaControl(payload);
            return res;
        },

        // 指标
        QUERY_QUOTA_LIST: async ({ commit }, payload) => {
            let res = await queryQuotaList(payload);
            commit('SET_QUOTA_LIST', res.data ?? {});
            commit('SET_QUOTA_BASE_LIST', { ...res.data } ?? {});
            return res;
        },

        QUERY_QUOTA_BASE_LIST: async ({}, payload) => {
            let res = await queryQuotaList(payload);
            return res;
        },

        ADD_QUOTA: async ({}, payload) => {
            let res = await addQuota(payload);
            return res;
        },

        QUERY_QUOTA_BY_USERID: async ({ commit }, payload) => {
            let res = await queryQuotaByUserId(payload);
            return res;
        },

        // 项目管理
        QUERY_CLAUSE_LIST: async ({ commit }, payload) => {
            let res = await queryClause(payload);
            if (res.code == 200) {
                commit('SET_CLAUSE_LIST', res.data ?? {});
            }
            return res;
        },

        ADD_CLAUSE: async ({}, payload) => {
            let res = await addClause(payload);
            return res;
        },

        // 补充客户
        QUERY_SUPPLY_CUSTOMER: async ({ commit }, payload) => {
            let res = await querySupplyCustomer(payload);
            if (res?.code == 200) {
                commit('SET_SUPPLY_LIST', res.data ?? {});
            }
            return res;
        },

        UPDATE_SUPPLY_CUSTOMER: async ({}, payload) => {
            let res = await updateSupplyCustomer(payload);
            return res;
        },

        DELETE_SUPPLY_CUSTOMER: async ({}, payload) => {
            let res = await deleteSupplyCustomer(payload);
            return res;
        },

        ADD_SUPPLY_CUSTOMER: async ({}, payload) => {
            let res = await addSupplyCustomer(payload);
            return res;
        },

        // 科室
        QUERY_ROOM_LIST: async ({ commit }, payload) => {
            let res = await QueryRoomList(payload);
            if (res?.code == 200) {
                commit('SET_ROOM_LIST', res.data ?? []);
            }
            return res;
        },

        QUERY_ROOM_TREE: async ({ commit }, payload) => {
            let res = await QueryRoomTree(payload);
            if (res?.code == 200) {
                let list = [];
                list.push({
                    typeId: -1,
                    typeName: '根目录'
                });
                commit('SET_ROOM_TREE', [...list, ...(res.data ?? [])]);
                commit('SET_ROOM_TREE_SELF', [...(res.data ?? [])]);
                commit('SET_ROOMS', flateTree(res.data ?? [], 'children'));
            }
            return res;
        },

        SAVE_ROOM: async ({ commit }, payload) => {
            let res = await SaveRoom(payload);
            return res;
        },

        DELETE_ROOM: async ({ commit }, payload) => {
            let res = await DeleteRoom(payload);
            return res;
        },

        UPDATE_SORT_ROOM: async ({ commit }, payload) => {
            let res = await UpdateSortRoom(payload);
            return res;
        },

        UPDATE_ROOM: async ({ commit }, payload) => {
            let res = await UpdateRoom(payload);
            return res;
        },

        // back-door
        ADD_CUSTOMER_ROOM_BACK: async ({}, payload) => {
            let res = await addCustomerDepartmentRelBack(payload);
            return res;
        },

        QUERY_CONFIG_LIST: async ({ commit }, payload) => {
            let res = await QueryConfigPage(payload);
            if (res?.code == 200) {
                commit('SET_CONFIG_LIST', res.data ?? {});
            }
            return res;
        },

        UPDATE_CONFIG: async ({ commit }, payload) => {
            let res = await UpdateConfig(payload);
            return res;
        },

        // 项目关系
        QUERY_BASE_LEFT_CUSTOMER: async ({ commit }, payload) => {
            let res = await QueryBaseLeftCustomer(payload);
            return res;
        },
        UPDATE_MEDICAL_ITEM: async ({ commit }, payload) => {
            let res = await UpdateMedicalItem(payload);
            return res;
        },

        // 联系人
        QUERY_DOCTOR_LIST: async ({ commit }, payload) => {
            let res = await QueryDoctorList(payload);
            return res;
        },

        QUERY_AGENT_LIST: async ({ commit }, payload) => {
            let res = await QueryAgentList(payload);
            if (res?.code == 200) {
                commit('SET_AGENT_LIST', res.data ?? []);
            } else {
                commit('SET_AGENT_LIST', []);
            }
            return res;
        },

        // 模板
        QUERY_KEYPOINT_TEMPLATE: async ({}, payload) => {
            let res = await QueryKeypointTemplate(payload);
            return res;
        },

        SAVE_KEYPOINT_TEMPLATE: async ({}, payload) => {
            let res = await SaveKeypointTemplate(payload);
            return res;
        },

        UPDATE_KEYPOINT_TEMPLATE: async ({}, payload) => {
            let res = await UpdateKeypointTemplate(payload);
            return res;
        },

        DELETE_KEYPOINT_TEMPLATE: async ({}, payload) => {
            let res = await DeleteKeypointTemplate(payload);
            return res;
        },
        GET_KEYPOINT_TEMPLATE_INFO: async ({}, payload) => {
            let res = await GetKeypointTemplateInfo(payload);
            return res;
        },

        QUERY_TEMPLATE_ACTION: async ({}, payload) => {
            let res = await QueryTemplateAction(payload);
            return res;
        },

        SAVE_TEMPLATE_ACTION: async ({}, payload) => {
            let res = await SaveTemplateAction(payload);
            return res;
        },
        UPDATE_TEMPLATE_ACTION: async ({}, payload) => {
            let res = await UpdateTemplateAction(payload);
            return res;
        },
        DELETE_TEMPLATE_ACTION: async ({}, payload) => {
            let res = await DeleteTemplateAction(payload);
            return res;
        }
    }
};
